export default __webpack_public_path__ + "static/media/img_036.3f9677a9.jpg";